module.exports = __webpack_public_path__ + "static/media/guardian-network-group-m-es.ad5a6b2d.webp";